/** Number formatting + period maths for the modern dashboards. */
export const fmtInt = (n) => (n == null || Number.isNaN(Number(n)) ? '—' : Number(n).toLocaleString('en-AU'));
export function fmtAud(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  const v = Number(n);
  if (Math.abs(v) >= 1e6) return `$${(v / 1e6).toFixed(v >= 1e7 ? 1 : 2).replace(/\.?0+$/, '')}M`;
  if (Math.abs(v) >= 1e3) return `$${Math.round(v / 1e3).toLocaleString('en-AU')}K`;
  return `$${Math.round(v).toLocaleString('en-AU')}`;
}
export const pct = (part, whole) => (whole > 0 ? Math.round((part / whole) * 100) : 0);

/** % change vs the previous period, or null when there is nothing to compare with. */
export function deltaPct(current, previous) {
  if (current == null || previous == null) return null;
  if (previous === 0) return current === 0 ? 0 : null;
  return Math.round(((current - previous) / previous) * 100);
}

